import { useState } from 'react';

const platforms = [
  { key: 'weibo', name: '新浪微博', icon: 'ri-weibo-line', color: 'text-primary-600' },
  { key: 'wechat', name: '微信朋友圈', icon: 'ri-wechat-line', color: 'text-accent-600' },
  { key: 'qq', name: 'QQ空间', icon: 'ri-qq-line', color: 'text-secondary-600' },
  { key: 'link', name: '复制链接', icon: 'ri-link', color: 'text-foreground-600' },
];

export default function ShareBar({ title }: { title: string }) {
  const [toast, setToast] = useState('');

  const share = async (name: string) => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(`${title} ${url}`);
    } catch {
      // clipboard 不可用时静默处理，仅做演示提示
    }
    setToast(`分享到「${name}」功能演示中：链接已复制，实际分享接口待接入`);
    window.setTimeout(() => setToast(''), 2600);
  };

  return (
    <div className="relative">
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-sm text-foreground-500 flex items-center gap-1.5">
          <i className="ri-share-forward-line"></i> 分享：
        </span>
        {platforms.map((p) => (
          <button
            key={p.key}
            type="button"
            onClick={() => share(p.name)}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-100 text-sm text-foreground-700 hover:bg-background-200 transition-colors whitespace-nowrap"
          >
            <i className={`${p.icon} ${p.color}`}></i> {p.name}
          </button>
        ))}
      </div>
      {toast && (
        <div className="mt-3 px-4 py-2.5 rounded-md bg-foreground-950 text-background-50 text-xs md:text-sm flex items-center gap-2 animate-fade-up">
          <i className="ri-information-line text-accent-400"></i>
          {toast}
        </div>
      )}
    </div>
  );
}